module.exports = __webpack_public_path__ + "static/stylelab_resume_edited.ac913eb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/stylelab_resume_edited.jpg
// module id = 666
// module chunks = 213534597649335